// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
}
.styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy .styles_right__Pqp9q {
  display: flex;
  align-items: center;
  gap: 20px;
}
.styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy .styles_right__Pqp9q .styles_date__\\+mGeV {
  display: flex;
  align-items: center;
  gap: 4px;
}
.styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy .styles_right__Pqp9q .styles_date__\\+mGeV img,
.styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy .styles_right__Pqp9q .styles_date__\\+mGeV svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy .styles_right__Pqp9q .styles_date__\\+mGeV span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

.styles_addEntryModal__NztLX .styles_innerModal__o73QF {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.styles_addEntryModal__NztLX .styles_innerModal__o73QF .styles_innerModalButtonGroup__1XNgE {
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 16px;
}
.styles_addEntryModal__NztLX .styles_footerBtns__DdCZk {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 16px;
}

.styles_timeManagementTabs__YDkmB {
  padding: 0 24px;
}
.styles_timeManagementTabs__YDkmB .styles_tabsInner__KcdDH {
  padding: 16px 0;
}

.styles_searchRow__AWUrM .styles_right__Pqp9q {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
}

.styles_formWrp__KEZ2k {
  max-height: 550px;
  overflow-y: auto;
}
.styles_formWrp__KEZ2k .styles_formField__6cR8T .styles_label__heQBg {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}

@media (max-width: 767px) {
  .styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy {
    padding: 16px;
  }
  .styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy .styles_right__Pqp9q {
    gap: 12px;
  }
  .styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy .styles_right__Pqp9q button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
}
@media (max-width: 425px) {
  .styles_pageWrap__Uhsl3 .styles_pageHeader__Z6SLy .styles_right__Pqp9q .styles_date__\\+mGeV span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/time-management/styles.module.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;AAAR;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAZ;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AADZ;AAGY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AADhB;AAGgB;;EAEI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AADpB;AAIgB;EACI,2BAAA;EACA,0BAAA;EACA,cAAA;AAFpB;;AAUI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAPR;AASQ;EACI,WAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AAPZ;AAWI;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AATR;;AAaA;EACI,eAAA;AAVJ;AAYI;EACI,eAAA;AAVR;;AAgBI;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AAbR;;AAiBA;EACI,iBAAA;EACA,gBAAA;AAdJ;AAiBQ;EACI,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAfZ;;AAoBA;EAEQ;IACI,aAAA;EAlBV;EAoBU;IACI,SAAA;EAlBd;EAoBc;IACI,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAlBlB;AACF;AAwBA;EAKoB;IACI,aAAA;EA1BtB;AACF","sourcesContent":[".pageWrap {\r\n    .pageHeader {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding: 16px 24px;\r\n        border-bottom: 1px solid var(--border);\r\n\r\n        h1 {\r\n            font: var(--h3);\r\n            font-weight: 700;\r\n            color: var(--primary-Text);\r\n            font-family: var(--font-bodoni-72);\r\n        }\r\n\r\n        .right {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 20px;\r\n\r\n            .date {\r\n                display: flex;\r\n                align-items: center;\r\n                gap: 4px;\r\n\r\n                img,\r\n                svg {\r\n                    width: 16px;\r\n                    height: 16px;\r\n                    object-fit: scale-down;\r\n                    display: block;\r\n                }\r\n\r\n                span {\r\n                    font: var(--body-font-four);\r\n                    color: var(--primary-Text);\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.addEntryModal {\r\n    .innerModal {\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        gap: 16px;\r\n\r\n        .innerModalButtonGroup {\r\n            width: 100%;\r\n            display: flex;\r\n            justify-content: end;\r\n            align-items: center;\r\n            gap: 16px;\r\n        }\r\n    }\r\n\r\n    .footerBtns {\r\n        display: flex;\r\n        justify-content: end;\r\n        align-items: center;\r\n        gap: 16px;\r\n    }\r\n}\r\n\r\n.timeManagementTabs {\r\n    padding: 0 24px;\r\n\r\n    .tabsInner {\r\n        padding: 16px 0;\r\n\r\n    }\r\n}\r\n\r\n.searchRow {\r\n    .right {\r\n        display: flex;\r\n        justify-content: end;\r\n        align-items: center;\r\n        gap: 10px;\r\n    }\r\n}\r\n\r\n.formWrp {\r\n    max-height: 550px;\r\n    overflow-y: auto;\r\n\r\n    .formField {\r\n        .label {\r\n            font: var(--body-font-three);\r\n            color: var(--secondary-Text);\r\n            display: block;\r\n            margin-bottom: 4px;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .pageWrap {\r\n        .pageHeader {\r\n            padding: 16px;\r\n\r\n            .right {\r\n                gap: 12px;\r\n\r\n                button {\r\n                    min-height: 35px;\r\n                    padding: 7px 10px;\r\n                    font-size: 12px;\r\n                    text-align: center;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 425px) {\r\n    .pageWrap {\r\n        .pageHeader {\r\n            .right {\r\n                .date {\r\n                    span {\r\n                        display: none;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `styles_pageWrap__Uhsl3`,
	"pageHeader": `styles_pageHeader__Z6SLy`,
	"right": `styles_right__Pqp9q`,
	"date": `styles_date__+mGeV`,
	"addEntryModal": `styles_addEntryModal__NztLX`,
	"innerModal": `styles_innerModal__o73QF`,
	"innerModalButtonGroup": `styles_innerModalButtonGroup__1XNgE`,
	"footerBtns": `styles_footerBtns__DdCZk`,
	"timeManagementTabs": `styles_timeManagementTabs__YDkmB`,
	"tabsInner": `styles_tabsInner__KcdDH`,
	"searchRow": `styles_searchRow__AWUrM`,
	"formWrp": `styles_formWrp__KEZ2k`,
	"formField": `styles_formField__6cR8T`,
	"label": `styles_label__heQBg`
};
export default ___CSS_LOADER_EXPORT___;
